export function createSelectOptions(options, includeEmptyDefault = true) {
	if (options?.length <= 0) return [];

	const resetValue = { value: '', content: '' };
	const mappedValues =
		options
			?.filter((value) => value.length > 0) // Remove empty values.
			?.map((value) => ({ value, content: value })) ?? // Convert to an object with content.
		[];

	return includeEmptyDefault ? [resetValue, ...mappedValues] : mappedValues;
}
